import script from "./LiveFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"

import "./LiveFixtureDoubleMarket.vue?vue&type=style&index=0&id=1aa0d62d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa0d62d"]])

export default __exports__